import { CordProvider } from '@cord-sdk/react';
import _ from 'lodash';
import React from 'react';
/**
 * This informer context is used for Cord components
 * whether CordProvider is present as a descendent
 * otherwise there are lots of console errors seen
 */
export const CordContextInformer = React.createContext(false);
/**
 * Top Level Provider. Given a clientAuthToken
 * all cord components will only render or work inside
 * this provider
 * To do a sample test you can use a sample client token from
 * https://docs.cord.com/get-started/integration-guide/#Frontend:%20Add%20a%20Cord%20component
 *
 * Also make sure this wrapper should be present in only one MFE app
 */
export const CordContextProvider = ({ children, cordClientToken, enableAnnotation = true, enableScreenshotCapture = false, }) => {
    if (!enableAnnotation || _.isEmpty(cordClientToken)) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement(CordProvider, { cordScriptUrl: 'https://app.commentapp.thoughtspot.cloud/sdk/v1/sdk.latest.js', clientAuthToken: cordClientToken, enableScreenshotCapture: enableScreenshotCapture, enableTasks: false, screenshotOptions: { capture_when: [] } },
        React.createElement(CordContextInformer.Provider, { value: enableAnnotation }, children)));
};
//# sourceMappingURL=wrap-cord-provider.js.map